import React, { Fragment, useEffect, useState } from "react";
import { Button, ButtonGroup, Modal, ModalBody, ModalHeader } from "reactstrap";
import { fetchMonitorItem, updateAlertMethod } from "../../api";

const MonitorMethodModal = (props) => {
  const isOpen = props.isOpen || false;
  const selectedItem = props.selectedItem || {};
  const onModalEvent = props.onModalEvent;
  const page = props.page;

  const [alertMethod, setAlertMethod] = useState("email");

  useEffect(() => {
    fetchMonitorItem(selectedItem.id).then((res) => {
      setAlertMethod(res.data.alert_method);
    });
  }, []);

  const BaseHeader = props.baseHeader || (() => <></>);

  const onButtonClick = (method) => {
    return () => {
      setAlertMethod(method);
      updateAlertMethod(selectedItem.id, method);
    };
  };

  return (
    <Modal isOpen={isOpen}>
      <div
        style={{
          marginTop: "10px",
          display: "flex",
          justifyContent: "space-between",
          width: "inherit",
        }}
      >
        <BaseHeader page={page} style={{ marginLeft: "10px" }} />
      </div>
      <ModalHeader>
        <p> Choose alert method </p>
      </ModalHeader>

      <ModalBody>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <ButtonGroup
            variant="contained"
            aria-label="outlined primary button group"
          >
            <Button
              onClick={onButtonClick("log")}
              color={alertMethod === "log" ? "primary" : "secondary"}
            >
              Log only
            </Button>
            <Button
              onClick={onButtonClick("email")}
              color={alertMethod === "email" ? "primary" : "secondary"}
            >
              Email
            </Button>
            <Button
              onClick={onButtonClick("web_notification")}
              color={
                alertMethod === "web_notification" ? "primary" : "secondary"
              }
            >
              Alert tab
            </Button>
          </ButtonGroup>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default MonitorMethodModal;
